<template>
  <div
    class="flex shrink-0 flex-wrap items-center gap-2"
    :class="compact ? 'justify-end' : 'justify-start md:justify-end'"
  >
    <user-profile-share-popover
      :user="user"
      :size="buttonSize"
      :is-current-user="isCurrentUser"
    />

    <template v-if="isCurrentUser">
      <user-current-user-settings-dropdown
        :user="user"
        v-model:privacy="privacyValue"
        show-edit-action
        :size="buttonSize"
        hide-view-info
      />
    </template>

    <template v-else>
      <user-add-connection-actions v-if="!isFriend" :user="user" :size="buttonSize" />
      <user-settings-dropdown v-if="isFriend" :user="user" hide-view-info>
        <u-button
          :icon="COMMON_ICONS.moreHorizontal"
          variant="outline"
          color="charcoal"
          :size="buttonSize"
        />
      </user-settings-dropdown>
    </template>
  </div>
</template>

<script setup>
  const props = defineProps({
    user: {
      type: Object,
      required: true
    },
    isCurrentUser: Boolean,
    compact: Boolean,
    privacy: String
  });

  const emit = defineEmits(['update:privacy']);
  const buttonSize = computed(() => props.compact ? 'sm' : 'md');
  const isFriend = computed(() => props.user.friendship?.status === FRIEND_STATUS.completed);
  const privacyValue = computed({
    get: () => props.privacy,
    set: value => emit('update:privacy', value)
  });
</script>
